var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("navbar"),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content", staticStyle: { "padding-bottom": "16px" } },
        [
          _c("p", [_vm._v("基础配置")]),
          _c(
            "el-form",
            {
              ref: "pageForm",
              staticClass: "info-form",
              attrs: {
                model: _vm.pageBasic,
                rules: _vm.pageRules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { label: "页面标题", prop: "title" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "450px" },
                    attrs: {
                      "show-word-limit": "",
                      maxlength: "6",
                      placeholder: "请输入页面标题",
                      clearable: "",
                    },
                    model: {
                      value: _vm.pageBasic.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.pageBasic, "title", $$v)
                      },
                      expression: "pageBasic.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "cupon-form",
                  attrs: { label: "页面入口选择", prop: "enterType" },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择页面入口",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.pageBasic.enterType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pageBasic, "enterType", $$v)
                        },
                        expression: "pageBasic.enterType",
                      },
                    },
                    _vm._l(
                      _vm.dictionaries.web_template_enter_type,
                      function (item, index) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入口图", prop: "img" } },
                [
                  _c("p", { staticStyle: { color: "#999999" } }, [
                    _vm._v(
                      " 建议上传长宽比为1：1的图片，每张上传大小不得超过2M，支持jpg、png格式。 "
                    ),
                  ]),
                  _c("upload-picture", {
                    attrs: { imgUrl: _vm.pageBasic.img },
                    on: { getUrl: _vm.getBasicImg },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "页面顺序", prop: "pageOrder" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      placeholder: "数字越大排位越靠前",
                      "show-word-limit": "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.pageBasic.pageOrder,
                      callback: function ($$v) {
                        _vm.$set(_vm.pageBasic, "pageOrder", $$v)
                      },
                      expression: "pageBasic.pageOrder",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { label: "分享标题", prop: "shareTitle" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "450px" },
                    attrs: {
                      "show-word-limit": "",
                      maxlength: "12",
                      placeholder: "请输入页面标题",
                      clearable: "",
                    },
                    model: {
                      value: _vm.pageBasic.shareTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.pageBasic, "shareTitle", $$v)
                      },
                      expression: "pageBasic.shareTitle",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { label: "分享副标题", prop: "shareContent" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "450px" },
                    attrs: {
                      "show-word-limit": "",
                      maxlength: "30",
                      placeholder: "请输入页面标题",
                      clearable: "",
                    },
                    model: {
                      value: _vm.pageBasic.shareContent,
                      callback: function ($$v) {
                        _vm.$set(_vm.pageBasic, "shareContent", $$v)
                      },
                      expression: "pageBasic.shareContent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分享图片", prop: "shareImg" } },
                [
                  _c("p", { staticStyle: { color: "#999999" } }, [
                    _vm._v(
                      " 建议上传长宽比为1：1的图片，每张上传大小不得超过2M，支持jpg、png格式。 "
                    ),
                  ]),
                  _c("upload-picture", {
                    attrs: { imgUrl: _vm.pageBasic.shareImg },
                    on: { getUrl: _vm.getBasicImg1 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content", staticStyle: { "padding-bottom": "16px" } },
        [
          _c("p", [_vm._v("页面配置")]),
          _c("div", { staticClass: "content page-content" }, [
            _c("div", [
              _c("div", { staticClass: "phone-view" }, [
                _c("div", { staticClass: "view-title" }, [
                  _vm._v(_vm._s(_vm.pageBasic.pageName)),
                ]),
                _c(
                  "div",
                  {
                    ref: "viewContent",
                    staticClass: "view-content",
                    style: {
                      "background-color":
                        _vm.pageBasic.bgColor && _vm.pageBasic.bgType == "2"
                          ? _vm.pageBasic.bgColor
                          : "",
                      "background-image":
                        "url(" +
                        (_vm.pageBasic.bgImg && _vm.pageBasic.bgType == "3"
                          ? _vm.pageBasic.bgImg
                          : "") +
                        ")",
                    },
                  },
                  [
                    _vm._l(_vm.viewData, function (item, index) {
                      return [
                        item.typeFlag == 1
                          ? _c(
                              "div",
                              {
                                ref: "viewModul" + index,
                                refInFor: true,
                                staticClass: "view-picture",
                                style: {
                                  height: item.imageModelInfo.img ? "auto" : "",
                                },
                                on: {
                                  mouseenter: function ($event) {
                                    return _vm.handleShowMask($event, index)
                                  },
                                  mouseleave: function ($event) {
                                    return _vm.handleCloseMask($event, index)
                                  },
                                },
                              },
                              [
                                _c("div", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        item.showViewMask || item.showViewMask2,
                                      expression:
                                        "item.showViewMask || item.showViewMask2",
                                    },
                                  ],
                                  staticClass: "view-picture-mask",
                                  attrs: { "data-idx": index },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleView(
                                        $event,
                                        index,
                                        item.typeFlag
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          item.showViewMask ||
                                          item.showViewMask2,
                                        expression:
                                          "item.showViewMask || item.showViewMask2",
                                      },
                                    ],
                                    staticClass: "view-bar",
                                  },
                                  [
                                    index > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "view-bar-btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toUp(index)
                                              },
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "icon-down icon-rotate",
                                              attrs: {
                                                src: require("../../assets/icon-down.png"),
                                                alt: "",
                                              },
                                            }),
                                            _c("span", [_vm._v("向上")]),
                                          ]
                                        )
                                      : _vm._e(),
                                    index < _vm.viewData.length - 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "view-bar-btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toDown(index)
                                              },
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "icon-down",
                                              attrs: {
                                                src: require("../../assets/icon-down.png"),
                                                alt: "",
                                              },
                                            }),
                                            _c("span", [_vm._v("向下")]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "view-bar-btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showDeleteView(
                                              index,
                                              item.typeFlag
                                            )
                                          },
                                        },
                                      },
                                      [_c("span", [_vm._v("删除")])]
                                    ),
                                  ]
                                ),
                                item.imageModelInfo.img
                                  ? _c("img", {
                                      staticClass: "picture-img",
                                      attrs: {
                                        src: item.imageModelInfo.img,
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        item.typeFlag == 2
                          ? _c(
                              "div",
                              {
                                ref: "viewModul" + index,
                                refInFor: true,
                                staticClass: "view-picture",
                                staticStyle: { height: "auto" },
                                on: {
                                  mouseenter: function ($event) {
                                    return _vm.handleShowMask($event, index)
                                  },
                                  mouseleave: function ($event) {
                                    return _vm.handleCloseMask($event, index)
                                  },
                                },
                              },
                              [
                                _c("div", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        item.showViewMask || item.showViewMask2,
                                      expression:
                                        "item.showViewMask || item.showViewMask2",
                                    },
                                  ],
                                  staticClass: "view-picture-mask",
                                  attrs: { "data-idx": index },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleView(
                                        $event,
                                        index,
                                        item.typeFlag
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          item.showViewMask ||
                                          item.showViewMask2,
                                        expression:
                                          "item.showViewMask || item.showViewMask2",
                                      },
                                    ],
                                    staticClass: "view-bar",
                                  },
                                  [
                                    index > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "view-bar-btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toUp(index)
                                              },
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "icon-down icon-rotate",
                                              attrs: {
                                                src: require("../../assets/icon-down.png"),
                                                alt: "",
                                              },
                                            }),
                                            _c("span", [_vm._v("向上")]),
                                          ]
                                        )
                                      : _vm._e(),
                                    index < _vm.viewData.length - 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "view-bar-btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toDown(index)
                                              },
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "icon-down",
                                              attrs: {
                                                src: require("../../assets/icon-down.png"),
                                                alt: "",
                                              },
                                            }),
                                            _c("span", [_vm._v("向下")]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "view-bar-btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showDeleteView(
                                              index,
                                              item.typeFlag
                                            )
                                          },
                                        },
                                      },
                                      [_c("span", [_vm._v("删除")])]
                                    ),
                                  ]
                                ),
                                item.goodsModelInfo.bindingType == "1"
                                  ? _c(
                                      "div",
                                      { staticClass: "tag-menu-box" },
                                      _vm._l(
                                        item.goodsModelInfo.tagList,
                                        function (itemx, index) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass: "tag-menu-item",
                                              class: {
                                                "tag-menu-active": index == 0,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(itemx.tagName) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                                item.goodsModelInfo.bindingType == "1"
                                  ? _c("div", { staticClass: "menu-bar" }, [
                                      _vm._m(1, true),
                                      _vm._m(2, true),
                                      _vm._m(3, true),
                                      _vm._m(4, true),
                                    ])
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "goods-box-two",
                                    class: {
                                      "goods-box-two-three":
                                        item.goodsModelInfo.layoutType == "1",
                                    },
                                  },
                                  [
                                    item.goodsModelInfo.bindingType == "2"
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: { overflow: "hidden" },
                                          },
                                          [
                                            item.goodsModelInfo.moreBtnType ==
                                            "1"
                                              ? _c(
                                                  "div",
                                                  { staticClass: "look-more" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.goodsModelInfo
                                                            .moreName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            item.goodsModelInfo.moreBtnType ==
                                            "2"
                                              ? _c("img", {
                                                  staticClass: "btn-img",
                                                  attrs: {
                                                    src: item.goodsModelInfo
                                                      .moreImg,
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    item.goodsModelInfo.layoutType == "2"
                                      ? _c(
                                          "div",
                                          { staticClass: "goods-two" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "goods-box" },
                                              [
                                                _vm._l(
                                                  item.goodsModelInfo.goodsList,
                                                  function (itemx, indexx) {
                                                    return [
                                                      indexx % 2 == 0
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "goods-info-box",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "goods-img-box",
                                                                  class: {
                                                                    "border-style":
                                                                      item
                                                                        .goodsModelInfo
                                                                        .borderType ==
                                                                      "2",
                                                                  },
                                                                  style: {
                                                                    "border-color":
                                                                      item
                                                                        .goodsModelInfo
                                                                        .borderColor,
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "goods-img",
                                                                    attrs: {
                                                                      src:
                                                                        itemx.headImg ||
                                                                        itemx.mainImage,
                                                                      alt: "",
                                                                    },
                                                                  }),
                                                                  item
                                                                    .goodsModelInfo
                                                                    .borderType ==
                                                                  "3"
                                                                    ? _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "goods-img-border",
                                                                          attrs:
                                                                            {
                                                                              src: item
                                                                                .goodsModelInfo
                                                                                .borderImg,
                                                                              alt: "",
                                                                            },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "good-dec",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "goods-title",
                                                                    },
                                                                    [
                                                                      itemx.resultType ==
                                                                      1
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "gift-tips",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "礼包"
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            itemx.name
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "goods-price-box",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "goods-price",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "￥" +
                                                                              _vm._s(
                                                                                itemx.price
                                                                              )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "goods-saled",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " 已售" +
                                                                              _vm._s(
                                                                                itemx.saleNum
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "goods-box" },
                                              [
                                                _vm._l(
                                                  item.goodsModelInfo.goodsList,
                                                  function (itemx, indexx) {
                                                    return [
                                                      indexx % 2 != 0
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "goods-info-box",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "goods-img-box",
                                                                  class: {
                                                                    "border-style":
                                                                      item
                                                                        .goodsModelInfo
                                                                        .borderType ==
                                                                      "2",
                                                                  },
                                                                  style: {
                                                                    "border-color":
                                                                      item
                                                                        .goodsModelInfo
                                                                        .borderColor,
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "goods-img",
                                                                    attrs: {
                                                                      src:
                                                                        itemx.headImg ||
                                                                        itemx.mainImage,
                                                                      alt: "",
                                                                    },
                                                                  }),
                                                                  item
                                                                    .goodsModelInfo
                                                                    .borderType ==
                                                                  "3"
                                                                    ? _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "goods-img-border",
                                                                          attrs:
                                                                            {
                                                                              src: item
                                                                                .goodsModelInfo
                                                                                .borderImg,
                                                                              alt: "",
                                                                            },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "good-dec",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "goods-title",
                                                                    },
                                                                    [
                                                                      itemx.resultType ==
                                                                      1
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "gift-tips",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "礼包"
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            itemx.name
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "goods-price-box",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "goods-price",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "￥" +
                                                                              _vm._s(
                                                                                itemx.price
                                                                              )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "goods-saled",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " 已售" +
                                                                              _vm._s(
                                                                                itemx.saleNum
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    item.goodsModelInfo.layoutType == "1"
                                      ? _c(
                                          "div",
                                          { staticClass: "goods-three" },
                                          _vm._l(
                                            item.goodsModelInfo.goodsList,
                                            function (itemx, indexx) {
                                              return _c(
                                                "div",
                                                {
                                                  staticClass: "three-info-box",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "three-img-box",
                                                      class: {
                                                        "border-style":
                                                          item.goodsModelInfo
                                                            .borderType == "2",
                                                      },
                                                      style: {
                                                        "border-color":
                                                          item.goodsModelInfo
                                                            .borderColor,
                                                      },
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "goods-img",
                                                        attrs: {
                                                          src:
                                                            itemx.headImg ||
                                                            itemx.mainImage,
                                                          alt: "",
                                                        },
                                                      }),
                                                      item.goodsModelInfo
                                                        .borderType == "3"
                                                        ? _c("img", {
                                                            staticClass:
                                                              "goods-img-border",
                                                            attrs: {
                                                              src: item
                                                                .goodsModelInfo
                                                                .borderImg,
                                                              alt: "",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "goods-title",
                                                    },
                                                    [
                                                      itemx.resultType == 1
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "gift-tips",
                                                            },
                                                            [_vm._v("礼包")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(itemx.name) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "goods-price-box",
                                                      staticStyle: {
                                                        "margin-top": "0",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "goods-price",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "￥" +
                                                              _vm._s(
                                                                itemx.price
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
              ]),
              _c(
                "div",
                { staticClass: "bottom-but" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "warning" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.go(-1)
                        },
                      },
                    },
                    [_vm._v("返回")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.saveFn } },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "settingbox" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.showSettingChange("1")
                        },
                      },
                    },
                    [_vm._v("背景设置")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.showSettingChange("2")
                        },
                      },
                    },
                    [_vm._v("添加图片模块")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.showSettingChange("3")
                        },
                      },
                    },
                    [_vm._v("添加商品模块")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showSettingBox == "1",
                      expression: "showSettingBox == '1'",
                    },
                  ],
                  staticClass: "custom",
                },
                [
                  _c("h5", { staticStyle: { "margin-bottom": "10px" } }, [
                    _vm._v("背景设置"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bg-setting" },
                    [
                      _c(
                        "el-form",
                        { ref: "bgFrom", attrs: { model: _vm.pageBasic } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "背景渲染", prop: "bgType" } },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "1" },
                                  model: {
                                    value: _vm.pageBasic.bgType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageBasic, "bgType", $$v)
                                    },
                                    expression: "pageBasic.bgType",
                                  },
                                },
                                [_vm._v("无背景")]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "2" },
                                  model: {
                                    value: _vm.pageBasic.bgType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageBasic, "bgType", $$v)
                                    },
                                    expression: "pageBasic.bgType",
                                  },
                                },
                                [_vm._v("背景颜色")]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "3" },
                                  model: {
                                    value: _vm.pageBasic.bgType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageBasic, "bgType", $$v)
                                    },
                                    expression: "pageBasic.bgType",
                                  },
                                },
                                [_vm._v("背景图片")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.pageBasic.bgType == "2",
                                  expression: "pageBasic.bgType == '2'",
                                },
                              ],
                              attrs: { label: "背景颜色", prop: "bgColor" },
                            },
                            [
                              _c("el-color-picker", {
                                model: {
                                  value: _vm.pageBasic.bgColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pageBasic, "bgColor", $$v)
                                  },
                                  expression: "pageBasic.bgColor",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.pageBasic.bgType == "3",
                                  expression: "pageBasic.bgType == '3'",
                                },
                              ],
                              attrs: { label: "背景图片", prop: "bgImg" },
                            },
                            [
                              _c("upload-picture", {
                                attrs: { imgUrl: _vm.pageBasic.bgImg },
                                on: { getUrl: _vm.getBgImage },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm.showSettingBox == "2" && _vm.viewData.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "custom",
                      style: {
                        position: "absolute",
                        top: _vm.fixTop + "px",
                        "margin-top": 0,
                        left: "410px",
                      },
                    },
                    [
                      _c("h5", { staticStyle: { "margin-bottom": "10px" } }, [
                        _vm._v("添加图片模块"),
                      ]),
                      _c("div", { staticClass: "bg-setting" }, [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c(
                            "div",
                            [
                              _c("upload-picture", {
                                attrs: {
                                  imgUrl:
                                    _vm.viewData[_vm.viewIndex].imageModelInfo
                                      .img,
                                },
                                on: { getUrl: _vm.getPictureImg },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { "margin-left": "20px" } },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "bgFrom",
                                  attrs: {
                                    model:
                                      _vm.viewData[_vm.viewIndex]
                                        .imageModelInfo,
                                  },
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: "", prop: "bindingType" },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "1" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .imageModelInfo.bindingType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .imageModelInfo,
                                                "bindingType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].imageModelInfo.bindingType",
                                          },
                                        },
                                        [_vm._v("无绑定")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "2" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .imageModelInfo.bindingType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .imageModelInfo,
                                                "bindingType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].imageModelInfo.bindingType",
                                          },
                                        },
                                        [_vm._v("绑定标签")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "3" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .imageModelInfo.bindingType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .imageModelInfo,
                                                "bindingType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].imageModelInfo.bindingType",
                                          },
                                        },
                                        [_vm._v("绑定链接")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .imageModelInfo.bindingType ==
                                            "2",
                                          expression:
                                            "\n                      viewData[viewIndex].imageModelInfo.bindingType == '2'\n                    ",
                                        },
                                      ],
                                      attrs: { label: "标签", prop: "" },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleShowTag(1)
                                            },
                                          },
                                        },
                                        [_vm._v("选择标签")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .imageModelInfo.bindingType ==
                                              2 &&
                                            _vm.viewData[_vm.viewIndex]
                                              .imageModelInfo.tagList &&
                                            _vm.viewData[_vm.viewIndex]
                                              .imageModelInfo.tagList.length >
                                              0,
                                          expression:
                                            "\n                      viewData[viewIndex].imageModelInfo.bindingType == 2 &&\n                      viewData[viewIndex].imageModelInfo.tagList &&\n                      viewData[viewIndex].imageModelInfo.tagList.length > 0\n                    ",
                                        },
                                      ],
                                      attrs: { label: "已选", prop: "" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "labelbox",
                                          staticStyle: { "flex-wrap": "wrap" },
                                        },
                                        _vm._l(
                                          _vm.viewData[_vm.viewIndex]
                                            .imageModelInfo.tagList,
                                          function (item, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: "dd" + item.id,
                                                staticClass: "labelitem",
                                                staticStyle: {
                                                  "margin-bottom": "10px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.tagName) +
                                                    " "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-circle-close labelicon",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteTag(
                                                        1,
                                                        index
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .imageModelInfo.bindingType == 3,
                                          expression:
                                            "\n                      viewData[viewIndex].imageModelInfo.bindingType == 3\n                    ",
                                        },
                                      ],
                                      attrs: { label: "页面链接", prop: "" },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder:
                                            "如有携带的参数值，请自行一起设置",
                                        },
                                        model: {
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .imageModelInfo.url,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.viewData[_vm.viewIndex]
                                                .imageModelInfo,
                                              "url",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "viewData[viewIndex].imageModelInfo.url",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.showSettingBox == "3" && _vm.viewData.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "custom",
                      style: {
                        position: "absolute",
                        top: _vm.fixTop + "px",
                        "margin-top": 0,
                        left: "410px",
                      },
                    },
                    [
                      _c("h5", { staticStyle: { "margin-bottom": "10px" } }, [
                        _vm._v("添加商品模块"),
                      ]),
                      _c("div", { staticClass: "bg-setting" }, [
                        _c("div", [
                          _c(
                            "div",
                            { staticStyle: { "margin-left": "20px" } },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "goodsModelInfo",
                                  attrs: {
                                    model:
                                      _vm.viewData[_vm.viewIndex]
                                        .goodsModelInfo,
                                  },
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "绑定商品",
                                        prop: "bgType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "1" },
                                          on: {
                                            change: function ($event) {
                                              return _vm.getTagGoodsChange(
                                                $event,
                                                _vm.viewIndex
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo.bindingType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo,
                                                "bindingType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].goodsModelInfo.bindingType",
                                          },
                                        },
                                        [_vm._v("绑定标签")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "2" },
                                          on: {
                                            change: function ($event) {
                                              return _vm.getTagGoodsChange(
                                                $event,
                                                _vm.viewIndex
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo.bindingType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo,
                                                "bindingType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].goodsModelInfo.bindingType",
                                          },
                                        },
                                        [_vm._v("选择商品")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.bindingType ==
                                            "1",
                                          expression:
                                            "\n                      viewData[viewIndex].goodsModelInfo.bindingType == '1'\n                    ",
                                        },
                                      ],
                                      attrs: { label: "标签", prop: "" },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleShowTag(2)
                                            },
                                          },
                                        },
                                        [_vm._v("选择标签")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.bindingType ==
                                              "1" &&
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.tagList &&
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.tagList.length >
                                              0,
                                          expression:
                                            "\n                      viewData[viewIndex].goodsModelInfo.bindingType == '1' &&\n                      viewData[viewIndex].goodsModelInfo.tagList &&\n                      viewData[viewIndex].goodsModelInfo.tagList.length > 0\n                    ",
                                        },
                                      ],
                                      attrs: { label: "已选", prop: "" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "labelbox",
                                          staticStyle: { "flex-wrap": "wrap" },
                                        },
                                        _vm._l(
                                          _vm.viewData[_vm.viewIndex]
                                            .goodsModelInfo.tagList,
                                          function (item, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: "dd" + item.id,
                                                staticClass: "labelitem",
                                                staticStyle: {
                                                  "margin-bottom": "10px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.tagName) +
                                                    " "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-circle-close labelicon",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteTag(
                                                        2,
                                                        index
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.bindingType ==
                                            "2",
                                          expression:
                                            "\n                      viewData[viewIndex].goodsModelInfo.bindingType == '2'\n                    ",
                                        },
                                      ],
                                      attrs: { label: "按钮设置", prop: "" },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "3" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo.moreBtnType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo,
                                                "moreBtnType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].goodsModelInfo.moreBtnType",
                                          },
                                        },
                                        [_vm._v("无按钮")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "1" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo.moreBtnType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo,
                                                "moreBtnType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].goodsModelInfo.moreBtnType",
                                          },
                                        },
                                        [_vm._v("文字名称")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "2" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo.moreBtnType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo,
                                                "moreBtnType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].goodsModelInfo.moreBtnType",
                                          },
                                        },
                                        [_vm._v("上传图片")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo.moreBtnType !=
                                                "3",
                                              expression:
                                                "\n                        viewData[viewIndex].goodsModelInfo.moreBtnType != '3'\n                      ",
                                            },
                                          ],
                                          staticStyle: {
                                            "margin-left": "70px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.viewData[_vm.viewIndex]
                                                      .goodsModelInfo
                                                      .moreBtnType == "1",
                                                  expression:
                                                    "\n                          viewData[viewIndex].goodsModelInfo.moreBtnType ==\n                          '1'\n                        ",
                                                },
                                              ],
                                              attrs: { label: "", prop: "" },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "80%" },
                                                attrs: {
                                                  placeholder: "按钮文字",
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm.viewData[_vm.viewIndex]
                                                      .goodsModelInfo.moreName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.viewData[
                                                        _vm.viewIndex
                                                      ].goodsModelInfo,
                                                      "moreName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "\n                            viewData[viewIndex].goodsModelInfo.moreName\n                          ",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.viewData[_vm.viewIndex]
                                                      .goodsModelInfo
                                                      .moreBtnType == "2",
                                                  expression:
                                                    "\n                          viewData[viewIndex].goodsModelInfo.moreBtnType ==\n                          '2'\n                        ",
                                                },
                                              ],
                                              attrs: { label: "", prop: "" },
                                            },
                                            [
                                              _c("upload-picture", {
                                                attrs: {
                                                  imgUrl:
                                                    _vm.viewData[_vm.viewIndex]
                                                      .goodsModelInfo.moreImg,
                                                },
                                                on: { getUrl: _vm.getmoreImg },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.bindingType ==
                                              "2" &&
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.moreBtnType !=
                                              "3",
                                          expression:
                                            "\n                      viewData[viewIndex].goodsModelInfo.bindingType == '2' &&\n                      viewData[viewIndex].goodsModelInfo.moreBtnType != '3'\n                    ",
                                        },
                                      ],
                                      attrs: { label: "按钮跳转", prop: "" },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "1" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo.moreHrefType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo,
                                                "moreHrefType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "\n                        viewData[viewIndex].goodsModelInfo.moreHrefType\n                      ",
                                          },
                                        },
                                        [_vm._v("绑定标签")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "2" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo.moreHrefType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo,
                                                "moreHrefType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "\n                        viewData[viewIndex].goodsModelInfo.moreHrefType\n                      ",
                                          },
                                        },
                                        [_vm._v("绑定链接")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-left": "70px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.viewData[_vm.viewIndex]
                                                      .goodsModelInfo
                                                      .moreHrefType == "1",
                                                  expression:
                                                    "\n                          viewData[viewIndex].goodsModelInfo.moreHrefType ==\n                          '1'\n                        ",
                                                },
                                              ],
                                              attrs: {
                                                label: "标签",
                                                prop: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "primary",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleShowTag(
                                                        3
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("选择标签")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.viewData[_vm.viewIndex]
                                                      .goodsModelInfo
                                                      .moreHrefType == "1" &&
                                                    _vm.viewData[_vm.viewIndex]
                                                      .goodsModelInfo
                                                      .btnTagList &&
                                                    _vm.viewData[_vm.viewIndex]
                                                      .goodsModelInfo.btnTagList
                                                      .length > 0,
                                                  expression:
                                                    "\n                          viewData[viewIndex].goodsModelInfo.moreHrefType ==\n                            '1' &&\n                          viewData[viewIndex].goodsModelInfo.btnTagList &&\n                          viewData[viewIndex].goodsModelInfo.btnTagList\n                            .length > 0\n                        ",
                                                },
                                              ],
                                              attrs: {
                                                label: "已选",
                                                prop: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "labelbox",
                                                  staticStyle: {
                                                    "flex-wrap": "wrap",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.viewData[_vm.viewIndex]
                                                    .goodsModelInfo.btnTagList,
                                                  function (item, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: "dd" + item.id,
                                                        staticClass:
                                                          "labelitem",
                                                        staticStyle: {
                                                          "margin-bottom":
                                                            "10px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.tagName
                                                            ) +
                                                            " "
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-circle-close labelicon",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteTag(
                                                                3,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.bindingType ==
                                              "2" &&
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.moreHrefType ==
                                              "2" &&
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.moreBtnType !=
                                              "3",
                                          expression:
                                            "\n                      viewData[viewIndex].goodsModelInfo.bindingType == '2' &&\n                      viewData[viewIndex].goodsModelInfo.moreHrefType ==\n                        '2' &&\n                      viewData[viewIndex].goodsModelInfo.moreBtnType != '3'\n                    ",
                                        },
                                      ],
                                      attrs: { label: "页面链接", prop: "" },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "80%" },
                                        attrs: {
                                          placeholder:
                                            "如有携带的参数值，请自行一起设置",
                                          size: "mini",
                                        },
                                        model: {
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.moreUrl,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo,
                                              "moreUrl",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "viewData[viewIndex].goodsModelInfo.moreUrl",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.bindingType ==
                                            "2",
                                          expression:
                                            "\n                      viewData[viewIndex].goodsModelInfo.bindingType == '2'\n                    ",
                                        },
                                      ],
                                      attrs: { label: "添加商品", prop: "" },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.showGoodsDialog = true
                                            },
                                          },
                                        },
                                        [_vm._v("添加")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.bindingType ==
                                            "2",
                                          expression:
                                            "\n                      viewData[viewIndex].goodsModelInfo.bindingType == '2'\n                    ",
                                        },
                                      ],
                                      attrs: { label: "布局方式", prop: "" },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "1" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo.layoutType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo,
                                                "layoutType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].goodsModelInfo.layoutType",
                                          },
                                        },
                                        [_vm._v("三图平铺")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "2" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo.layoutType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo,
                                                "layoutType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].goodsModelInfo.layoutType",
                                          },
                                        },
                                        [_vm._v("双图排列")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.viewData[_vm.viewIndex]
                                              .goodsModelInfo.bindingType ==
                                            "2",
                                          expression:
                                            "\n                      viewData[viewIndex].goodsModelInfo.bindingType == '2'\n                    ",
                                        },
                                      ],
                                      attrs: { label: "边框渲染", prop: "" },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "1" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo.borderType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo,
                                                "borderType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].goodsModelInfo.borderType",
                                          },
                                        },
                                        [_vm._v("无边框")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "2" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo.borderType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo,
                                                "borderType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].goodsModelInfo.borderType",
                                          },
                                        },
                                        [_vm._v("边框颜色")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "3" },
                                          model: {
                                            value:
                                              _vm.viewData[_vm.viewIndex]
                                                .goodsModelInfo.borderType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.viewData[_vm.viewIndex]
                                                  .goodsModelInfo,
                                                "borderType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "viewData[viewIndex].goodsModelInfo.borderType",
                                          },
                                        },
                                        [_vm._v("边框图片")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-left": "70px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.viewData[_vm.viewIndex]
                                                      .goodsModelInfo
                                                      .borderType == "2",
                                                  expression:
                                                    "\n                          viewData[viewIndex].goodsModelInfo.borderType == '2'\n                        ",
                                                },
                                              ],
                                              attrs: { label: "", prop: "" },
                                            },
                                            [
                                              _c("el-color-picker", {
                                                model: {
                                                  value:
                                                    _vm.viewData[_vm.viewIndex]
                                                      .goodsModelInfo
                                                      .borderColor,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.viewData[
                                                        _vm.viewIndex
                                                      ].goodsModelInfo,
                                                      "borderColor",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "\n                            viewData[viewIndex].goodsModelInfo.borderColor\n                          ",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.viewData[_vm.viewIndex]
                                                      .goodsModelInfo
                                                      .borderType == "3",
                                                  expression:
                                                    "\n                          viewData[viewIndex].goodsModelInfo.borderType == '3'\n                        ",
                                                },
                                              ],
                                              attrs: { label: "", prop: "" },
                                            },
                                            [
                                              _c("upload-picture", {
                                                attrs: {
                                                  imgUrl:
                                                    _vm.viewData[_vm.viewIndex]
                                                      .goodsModelInfo.borderImg,
                                                },
                                                on: {
                                                  getUrl: _vm.getborderImg,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { padding: "0 20px" },
          attrs: {
            title: "选择标签",
            visible: _vm.showTagDialog,
            width: "1080px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showTagDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "tag—table-box" },
            [
              _c(
                "el-form",
                {
                  ref: "tagForm",
                  attrs: {
                    model: _vm.searchTag,
                    inline: true,
                    id: "search",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "标签", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "标签名称" },
                        model: {
                          value: _vm.searchTag.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchTag, "name", $$v)
                          },
                          expression: "searchTag.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "分类", prop: "tagType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "", clearable: "" },
                          model: {
                            value: _vm.searchTag.tagType,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchTag, "tagType", $$v)
                            },
                            expression: "searchTag.tagType",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.goods_tag_type,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "类目", prop: "tagClass" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "", clearable: "" },
                          model: {
                            value: _vm.searchTag.tagClass,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchTag, "tagClass", $$v)
                            },
                            expression: "searchTag.tagClass",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.goods_tag_class,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticClass: "primary-mini",
                        on: {
                          click: function ($event) {
                            return _vm.fetchTagData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "primary-mini",
                        on: {
                          click: function ($event) {
                            return _vm.fetchTagData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ]),
                ],
                1
              ),
              _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                _c(
                  "div",
                  {
                    staticClass: "primary-plain",
                    on: {
                      click: function ($event) {
                        return _vm.batchSelectTag(1)
                      },
                    },
                  },
                  [_vm._v("批量选择")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "primary-plain",
                    on: {
                      click: function ($event) {
                        return _vm.batchSelectTag(2)
                      },
                    },
                  },
                  [_vm._v("批量取消")]
                ),
              ]),
              _c(
                "el-table",
                {
                  ref: "labelTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tagList,
                    "header-cell-style": {
                      background: "#F8F8F8",
                      color: "#333333",
                    },
                    "cell-style": { padding: "0" },
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", { attrs: { type: "selection" } }),
                  _c("el-table-column", {
                    attrs: { label: "标签", prop: "tagName" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "排序", prop: "sort" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "标签分类", prop: "typeName" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "标签类目", prop: "className" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "是否对外展示", prop: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("p", [
                              _vm._v(
                                _vm._s(scope.row.showFlag == 1 ? "是" : "否")
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", prop: "tagName" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "tag-status" }, [
                              _c("div", {
                                staticClass: "circle",
                                style: {
                                  "background-color":
                                    scope.row.status == 1 ? "#67c23a" : "red",
                                },
                              }),
                              _c("span", [
                                _vm._v(_vm._s(scope.row.statusLabel)),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", prop: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !scope.row.selected
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSelectTag(scope)
                                      },
                                    },
                                  },
                                  [_vm._v("选择")]
                                )
                              : _vm._e(),
                            scope.row.selected
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "red" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSelectTag(scope)
                                      },
                                    },
                                  },
                                  [_vm._v("取消")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "20px",
                    "background-color": "#f8f8f8",
                    overflow: "hidden",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { float: "right" } },
                    [
                      _vm.tagList.length > 0
                        ? _c("el-pagination", {
                            attrs: {
                              background: "",
                              "current-page": _vm.labelPageNo,
                              "page-sizes": [5, 10, 20],
                              "page-size": _vm.labelPageSize,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.labelTotalNum,
                            },
                            on: {
                              "size-change": _vm.onSizeChange,
                              "current-change": _vm.onCurrentChange,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                {
                  staticClass: "primary-gray",
                  on: {
                    click: function ($event) {
                      return _vm.closeTagDialog($event, 1)
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "div",
                {
                  staticClass: "primary-button",
                  on: {
                    click: function ($event) {
                      return _vm.closeTagDialog($event, 2)
                    },
                  },
                },
                [_vm._v(" 确 定 ")]
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加商品",
            visible: _vm.showGoodsDialog,
            width: "1010px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showGoodsDialog = $event
            },
          },
        },
        [
          _vm.viewData.length > 0 && _vm.viewData[_vm.viewIndex].goodsModelInfo
            ? _c(
                "div",
                { staticClass: "tag—table-box" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "searchGoods",
                      attrs: {
                        model: _vm.searchGoods,
                        inline: true,
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "商品名称" },
                            model: {
                              value: _vm.searchGoods.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchGoods, "name", $$v)
                              },
                              expression: "searchGoods.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品标签/类别",
                            prop: "tagOrCategory",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "商品标签/类别",
                            },
                            model: {
                              value: _vm.searchGoods.tagOrCategory,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchGoods, "tagOrCategory", $$v)
                              },
                              expression: "searchGoods.tagOrCategory",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-form-item", [
                        _c(
                          "div",
                          {
                            staticClass: "primary-mini",
                            on: {
                              click: function ($event) {
                                return _vm.fetchGoodsData("search")
                              },
                            },
                          },
                          [_vm._v(" 查询 ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "primary-mini",
                            on: {
                              click: function ($event) {
                                return _vm.fetchGoodsData("reset")
                              },
                            },
                          },
                          [_vm._v(" 重置 ")]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                    _c("span", { staticStyle: { "font-weight": "bold" } }, [
                      _vm._v("选择商品："),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "primary-plain",
                        on: {
                          click: function ($event) {
                            return _vm.batchSelectGoods(1)
                          },
                        },
                      },
                      [_vm._v("批量选择")]
                    ),
                  ]),
                  _c(
                    "el-table",
                    {
                      ref: "goodsTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.goodsList,
                        "header-cell-style": {
                          background: "#F8F8F8",
                          color: "#333333",
                        },
                        "cell-style": { padding: "10px" },
                      },
                      on: {
                        "selection-change": _vm.handleSelectionGoodsChange,
                      },
                    },
                    [
                      _c("el-table-column", { attrs: { type: "selection" } }),
                      _c("el-table-column", {
                        attrs: { label: "商品ID", prop: "id" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "商品名称", prop: "name" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("p", { staticClass: "goods-name" }, [
                                    _vm._v(_vm._s(scope.row.name)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3340312673
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "商品图片", prop: "typeFlagLabel" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("img", {
                                    staticClass: "table-goods-img",
                                    attrs: { src: scope.row.headImg, alt: "" },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1405262337
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "商品状态", prop: "tagName" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "tag-status" }, [
                                    _c("div", {
                                      staticClass: "circle",
                                      style: {
                                        "background-color":
                                          scope.row.statusLabel.indexOf(
                                            "上架"
                                          ) > -1
                                            ? "#67c23a"
                                            : "red",
                                      },
                                    }),
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.statusLabel)),
                                    ]),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3303601932
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", prop: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleSelectGoods(scope, 1)
                                        },
                                      },
                                    },
                                    [_vm._v("选择")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3592216410
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-bottom": "20px",
                        "background-color": "#f8f8f8",
                        overflow: "hidden",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { float: "right" } },
                        [
                          _vm.tagList.length > 0
                            ? _c("el-pagination", {
                                attrs: {
                                  background: "",
                                  "current-page": _vm.goodsPageNo,
                                  "page-sizes": [5, 10, 20],
                                  "page-size": _vm.goodsPageSize,
                                  layout:
                                    "total, sizes, prev, pager, next, jumper",
                                  total: _vm.goodsTotalNum,
                                },
                                on: {
                                  "size-change": _vm.onGoodsSizeChange,
                                  "current-change": _vm.onGoodsCurrentChange,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                    _c("span", { staticStyle: { "font-weight": "bold" } }, [
                      _vm._v("已选商品："),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "primary-plain",
                        on: {
                          click: function ($event) {
                            return _vm.batchSelectGoods(2)
                          },
                        },
                      },
                      [_vm._v("批量取消")]
                    ),
                  ]),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.viewData[_vm.viewIndex].goodsModelInfo
                          .selectedGoodsList,
                        "header-cell-style": {
                          background: "#F8F8F8",
                          color: "#333333",
                        },
                        "cell-style": { padding: "10px" },
                      },
                      on: {
                        "selection-change":
                          _vm.handleSelectionGoodsCancelChange,
                      },
                    },
                    [
                      _c("el-table-column", { attrs: { type: "selection" } }),
                      _c("el-table-column", {
                        attrs: { label: "商品ID", prop: "id" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "商品名称", prop: "name" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("p", { staticClass: "goods-name" }, [
                                    _vm._v(_vm._s(scope.row.name)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3340312673
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "商品图片", prop: "typeFlagLabel" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("img", {
                                    staticClass: "table-goods-img",
                                    attrs: {
                                      src:
                                        scope.row.headImg ||
                                        scope.row.mainImage,
                                      alt: "",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1224998189
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "商品状态", prop: "tagName" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "tag-status" }, [
                                    _c("div", {
                                      staticClass: "circle",
                                      style: {
                                        "background-color":
                                          scope.row.statusLabel.indexOf(
                                            "上架"
                                          ) > -1
                                            ? "#67c23a"
                                            : "red",
                                      },
                                    }),
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.statusLabel)),
                                    ]),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3303601932
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", prop: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "red" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleSelectGoods(scope, 2)
                                        },
                                      },
                                    },
                                    [_vm._v("取消")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2005717964
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                {
                  staticClass: "primary-gray",
                  on: {
                    click: function ($event) {
                      _vm.showGoodsDialog = false
                      _vm.$refs.goodsTable.clearSelection()
                    },
                  },
                },
                [_vm._v(" 取 消 ")]
              ),
              _c(
                "div",
                {
                  staticClass: "primary-button",
                  on: {
                    click: function ($event) {
                      _vm.showGoodsDialog = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            visible: _vm.dialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("i", {
              staticClass: "el-icon-warning",
              staticStyle: { color: "red" },
            }),
            _vm._v(" 删除提示 "),
          ]),
          _c("div", [_vm._v("删除后已设置内容将无法恢复，是否继续？")]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteViewFn()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [_c("h2", [_vm._v("新增")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "menu-item" }, [
      _c("span", [_vm._v("综合")]),
      _c("img", {
        staticClass: "icon-next",
        attrs: { src: require("../../assets/icon_next.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "menu-item" }, [
      _c("span", [_vm._v("销量")]),
      _c("img", {
        staticClass: "icon-next",
        attrs: { src: require("../../assets/icon_next.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "menu-item" }, [
      _c("span", [_vm._v("价格")]),
      _c("img", {
        staticClass: "icon-next",
        attrs: { src: require("../../assets/icon_next.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "menu-item" }, [
      _c("img", {
        staticClass: "icon-heng",
        attrs: { src: require("../../assets/icon_shu.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }